import { Badge, Box, Text } from '@frontend/components';

type NotificationBusinessNameBadgeProps = {
  businessName: string;
  isCurrent: boolean;
};

const NotificationBusinessNameBadge = ({
  businessName,
  isCurrent,
}: NotificationBusinessNameBadgeProps) => (
  <Box marginRight="4px">
    <Badge
      bg={isCurrent ? 'feature.secondary' : 'white'}
      borderColor="feature.secondary"
      size="xs"
      height={2}
      variant={isCurrent ? 'solid' : 'outline'}
    >
      <Text
        color={isCurrent ? 'white' : 'feature.secondary'}
        size="xs"
        height={2}
        textOverflow={'ellipsis'}
      >
        {businessName}
      </Text>
    </Badge>
  </Box>
);

export default NotificationBusinessNameBadge;
